export const SEND_PROJECT = 'SEND_PROJECT';
export const   GET_PROJECT = 'GET_PROJECT';
export const  SET_PROJECT_ERRORS = ' SET_PROJECT_ERRORS';
export const  GET_PROJECT_RESULT = 'GET_PROJECT_RESULT';
export const  GET_PROJECT_STATUS = ' GET_PROJECT_STATUS';
export const PROJECT_RESULT     = 'PROJECT_RESULT'
export const ADD_PROJECT = 'ADD_PROJECT'
export const GET_PROJECT_STUDENTS = 'GET_PROJECT_STUDENTS'
export const GRADE_STUDENT_PROJECTS = 'GRADE_STUDENT_PROJECTS'